/**
 * Created by zzy on 2019/8/15.
 */
import ModifyVideoPatrol from './ModifyVideoPatrol.vue'
export default ModifyVideoPatrol



// WEBPACK FOOTER //
// ./src/views/monitoring/liveVideo/modifyVideoPatrol/index.js